import axios from 'axios';

export enum ENDPOINTS {
  calc_ar = 'calc_ar',
  facility_summary = 'facility_summary',
  equipment_summary = 'equipment_summary',
  facility_data = 'facility_data',
  benchmark = 'benchmark',
}

const BASE_URL = 'https://amibefunc-prod.azurewebsites.net/api/equipment_data';
const FACILITY_SUMMARY_URL =
  'https://amibefunc-prod.azurewebsites.net/api/facility_summary';
const EQUIPMENT_SUMMARY_URL =
  'https://amibefunc-prod.azurewebsites.net/api/equipment_summary';
const FACILITY_DATA_URL =
  'https://amibefunc-prod.azurewebsites.net/api/facility_data';
const BENCHMARK_DATA_URL = 'https://amibefunc-prod.azurewebsites.net/api/benchmark';


export interface ApiParams {
  quarter: string;
  year: number | string;
  sponsored?: number | string;
  og?: number | string;
  facility_type?: string | string[];
  equipment_type?: string;
}

export interface ApiFacilityParams {
  quarter: string;
  year: number | string;
  facility_type?: string;
  equipment_type?: string;
}

const fetchDataSettings = {
  calc_ar: {
    url: BASE_URL,
    params: (params: ApiParams) => {
      return {
        quarter: params.quarter.toString(),
        year: params.year.toString(),
      };
    },
  },
  facility_summary: {
    url: FACILITY_SUMMARY_URL,
    params: (params: ApiFacilityParams) => {
      return {
        quarter: params.quarter.toString(),
        year: params.year.toString(),
      };
    },
  },
  equipment_summary: {
    url: EQUIPMENT_SUMMARY_URL,
    params: (params: ApiFacilityParams) => {
      return {
        quarter: params.quarter.toString(),
        year: params.year.toString(),
      };
    },
  },
  facility_data: {
    url: FACILITY_DATA_URL,
    params: (params: ApiParams) => {
      return {
        quarter: params.quarter.toString(),
        year: params.year.toString(),
      };
    },
  },
  benchmark: {
    url: BENCHMARK_DATA_URL,
    params: (params: ApiParams) => {
      return {
        year: params.year.toString(),
      };
    },
  },
};

export const fetchData = async (type: ENDPOINTS, params: any) => {
  try {
    const queryParams = new URLSearchParams(
      fetchDataSettings[type].params(params),
    );

    const response = await axios.get(
      `${fetchDataSettings[type].url}?${queryParams.toString()}`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'DELETE, POST, GET, OPTIONS',
          'x-functions-key':
            'Uq2hECBClRpGy8pSdUggSUfkQ0sZm40JioenpI_cfvWaAzFunidcQg==',
        },
        responseEncoding: 'latin1',
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};
